// extracted by mini-css-extract-plugin
export default {"verification-container":"styles__verification-container--lGhUB"};